import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var _excluded = ["offers"];
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext, useEffect, useState } from "react";
import { useApolloClient } from "@apollo/client";
import { AppExperimentContext, emitAddToWishlist, emitNotify, emitProductView } from "@catchoftheday/analytics";
import { MutationType, useToast } from "@catchoftheday/cart-components";
import { Box, Flex, LoadingSpinner, NoSSR } from "@catchoftheday/cg-components";
import { WishlistContext } from "@catchoftheday/common-vendors";
import { CustomerContext, logIn } from "@catchoftheday/customer";
import { CONSTANTS as HEADER_CONSTANTS } from "@catchoftheday/header";
import { isActiveOnePassMember, UpsellCTAWidgetContainer } from "@catchoftheday/onepass";
import { BNPLPaymentMethodsContainer } from "@catchoftheday/payments";
import { CoPurchasedRecommender, recordProductView, showRecommenderForSellerId } from "@catchoftheday/personalisation";
import { getSourceValuesFromQueryString, ProductBadge, ProductPrice, ProductPriceNew, SalesRulePromotionProgress, SalesRulePromotionTag } from "@catchoftheday/product-components";
import { cookies, date } from "@catchoftheday/utilities";
import { updateDataLayer, updateEcommerceData } from "@product-app/analytics/dataLayer";
import { DigitalProductIds } from "@product-app/consts";
import { BuyBoxDocument, useBuyBoxQuery } from "../../generated/graphql";
import { ErrorContainer } from "../ErrorContainer";
import { AttributeSelector } from "./AttributeSelector";
import { BuyBoxButtons } from "./BuyBoxButtons";
import { BuyBoxContainer } from "./BuyBoxContainer";
import { BuyBoxLoader } from "./BuyBoxLoader";
import { ChristmasDeliveryWidget } from "./ChristmasDeliveryWidget";
import { DeliveryEstimate } from "./DeliveryEstimate";
import { OfferSelector } from "./OfferSelector";
import { OnePassExclusive } from "./OnePassExclusive";
import { PersonalisedFields } from "./PersonalisedFields";
import { QuantitySelector } from "./QuantitySelector";
import { ShippingInformation } from "./ShippingInformation";
import { SizeChartsButton } from "./SizeCharts";
import { SoldOut } from "./SoldOut";
import { WarrantyInfo } from "./WarrantyInfo";
import { jsx as ___EmotionJSX } from "@emotion/react";

var BorderBox = function BorderBox(props) {
  return ___EmotionJSX(Box, _extends({
    py: 6,
    borderTop: 1,
    borderColor: "ui.borderColor"
  }, props));
};

export var BuyBox = function BuyBox(_ref) {
  var _data$productById, _data$productById$sel, _offer$variant$id, _offer$variant, _offer$variant2, _offer$seller, _customerData$club, _customerData$members, _customerData$members2, _offer$priceTag2, _offer$priceTag2$pric;

  var isTablet = _ref.isTablet,
      productId = _ref.productId,
      initialOfferId = _ref.offerId,
      eventId = _ref.eventId,
      headerRef = _ref.headerRef,
      salesRulePromotionProgress = _ref.salesRulePromotionProgress,
      onAddToCartSuccess = _ref.onAddToCartSuccess;

  var _getSourceValuesFromQ = getSourceValuesFromQueryString(),
      sourceId = _getSourceValuesFromQ.sourceId,
      sourceType = _getSourceValuesFromQ.sourceType,
      sourcePosition = _getSourceValuesFromQ.sourcePosition;

  var client = useApolloClient();

  var _useContext = useContext(AppExperimentContext),
      getExperiments = _useContext.getExperiments;

  var _getExperiments = getExperiments(["web_xmas_widget_nov_22", "product_card_redesign_jul23", "promotion_visibility_web_aug_24"]),
      _getExperiments$exper = _slicedToArray(_getExperiments.experiments, 3),
      xmasWidgetExperiment = _getExperiments$exper[0],
      productCardExperiment = _getExperiments$exper[1],
      promotionVisibilityExperiment = _getExperiments$exper[2],
      experimentLoading = _getExperiments.loading;

  var displayXmasWidget = (xmasWidgetExperiment === null || xmasWidgetExperiment === void 0 ? void 0 : xmasWidgetExperiment.bucket) === 1 && date.isBefore(new Date(), new Date("2022-12-25 23:59:59"));
  var isPromotionVisibilityExperimentPhase1 = !experimentLoading && promotionVisibilityExperiment && promotionVisibilityExperiment.bucket > 0;
  var isPromotionVisibilityExperimentPhase2 = !experimentLoading && promotionVisibilityExperiment && promotionVisibilityExperiment.bucket >= 2;

  var _useBuyBoxQuery = useBuyBoxQuery({
    variables: {
      productId: productId,
      selectedOfferId: initialOfferId
    },
    ssr: false
  }),
      data = _useBuyBoxQuery.data,
      loading = _useBuyBoxQuery.loading,
      error = _useBuyBoxQuery.error,
      refetch = _useBuyBoxQuery.refetch;

  var _useState = useState(1),
      chosenQuantity = _useState[0],
      setQuantity = _useState[1];

  var _useState2 = useState(true),
      offerLoading = _useState2[0],
      setOfferLoading = _useState2[1];

  var _useState3 = useState(false),
      willNotify = _useState3[0],
      setWillNotify = _useState3[1];

  var _useState4 = useState(),
      wishlistItemId = _useState4[0],
      setWishlistItemId = _useState4[1];

  var _useContext2 = useContext(CustomerContext),
      customerData = _useContext2.data,
      customerLoading = _useContext2.loading;

  var _useContext3 = useContext(WishlistContext),
      deletedWishlistProductId = _useContext3.deletedWishlistProductId,
      setDeletedWishlistProductId = _useContext3.setDeletedWishlistProductId;

  var isLoggedIn = !!customerData;
  var selectedOfferId = (data === null || data === void 0 ? void 0 : (_data$productById = data.productById) === null || _data$productById === void 0 ? void 0 : (_data$productById$sel = _data$productById.selectedOffer) === null || _data$productById$sel === void 0 ? void 0 : _data$productById$sel.id) || initialOfferId;
  var addItemToWishlist = useToast({
    mutationType: MutationType.ADD_TO_WISHLIST
  });
  var addItemToNotifyWishlist = useToast({
    mutationType: MutationType.ADD_TO_NOTIFY_WISHLIST,
    showTickOnSuccess: false
  });
  var removeItemFromNotifyWishlist = useToast({
    mutationType: MutationType.REMOVE_FROM_NOTIFY_WISHLIST,
    showTickOnSuccess: false
  });
  var removeItemFromWishlist = useToast({
    mutationType: MutationType.REMOVE_FROM_WISHLIST
  });
  useEffect(function () {
    if (data !== null && data !== void 0 && data.productById) {
      updateEcommerceData(data.productById, sourceType);
      updateDataLayer(data.productById, customerData === null || customerData === void 0 ? void 0 : customerData.id);
    }
  }, [data === null || data === void 0 ? void 0 : data.productById, sourceType, customerData]);
  useEffect(function () {
    var _data$productById2;

    setWillNotify(!!(data !== null && data !== void 0 && (_data$productById2 = data.productById) !== null && _data$productById2 !== void 0 && _data$productById2.variants.find(function (opt) {
      var _opt$wishlist$wishlis;

      return (_opt$wishlist$wishlis = opt.wishlist.wishlistItem) === null || _opt$wishlist$wishlis === void 0 ? void 0 : _opt$wishlist$wishlis.notify;
    })));
  }, [data === null || data === void 0 ? void 0 : data.productById]);
  useEffect(function () {
    var _data$productById3, _data$productById3$va, _data$productById3$va2;

    setWishlistItemId(data === null || data === void 0 ? void 0 : (_data$productById3 = data.productById) === null || _data$productById3 === void 0 ? void 0 : (_data$productById3$va = _data$productById3.variants.find(function (opt) {
      var _opt$wishlist$wishlis2;

      return ((_opt$wishlist$wishlis2 = opt.wishlist.wishlistItem) === null || _opt$wishlist$wishlis2 === void 0 ? void 0 : _opt$wishlist$wishlis2.id) != null;
    })) === null || _data$productById3$va === void 0 ? void 0 : (_data$productById3$va2 = _data$productById3$va.wishlist.wishlistItem) === null || _data$productById3$va2 === void 0 ? void 0 : _data$productById3$va2.id);
    setOfferLoading(false);

    if (data !== null && data !== void 0 && data.productById) {
      var _data$productById$sel2;

      recordProductView({
        product: _objectSpread(_objectSpread({}, data.productById), {}, {
          priceTag: (_data$productById$sel2 = data.productById.selectedOffer) === null || _data$productById$sel2 === void 0 ? void 0 : _data$productById$sel2.priceTag
        }),
        limit: HEADER_CONSTANTS.MAX_ENHANCED_SEARCH_PRODUCTS_IN_VIEW
      });
    }
  }, [data === null || data === void 0 ? void 0 : data.productById]);
  useEffect(function () {
    if (deletedWishlistProductId == productId) {
      setWishlistItemId(undefined);
    }
  }, [deletedWishlistProductId, productId]);
  useEffect(function () {
    if (data !== null && data !== void 0 && data.productById) {
      client.writeQuery({
        query: BuyBoxDocument,
        data: data,
        variables: {
          productId: productId,
          selectedOfferId: initialOfferId
        },
        id: "Badges:".concat(productId)
      });

      if (productCardExperiment !== null && productCardExperiment !== void 0 && productCardExperiment.bucket) {
        var galleryTags = document.querySelector(".product-gallery-availability-tags");
        galleryTags === null || galleryTags === void 0 ? void 0 : galleryTags.setAttribute("style", "display: none");
      }
    }
  }, [client, productId, initialOfferId, data, productCardExperiment]);

  if (loading && !data) {
    return ___EmotionJSX(BuyBoxContainer, null, ___EmotionJSX(NoSSR, null, ___EmotionJSX(BuyBoxLoader, null)));
  }

  if (error || !(data !== null && data !== void 0 && data.productById)) {
    return ___EmotionJSX(BuyBoxContainer, null, ___EmotionJSX(ErrorContainer, {
      retry: function retry() {
        return refetch({
          productId: productId
        });
      }
    }));
  }

  var redirectToLogin = function redirectToLogin(redirectAction) {
    cookies.set("productRedirectAction", redirectAction);
    logIn({
      returnToSelf: true
    });
  };

  var notifyWishlist = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(variantId) {
      var willNotifyAction,
          updateNotifyList,
          _yield$updateNotifyLi,
          status,
          _data$productById4,
          _yield$refetch,
          _data,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              willNotifyAction = _args.length > 1 && _args[1] !== undefined ? _args[1] : willNotify;

              if (isLoggedIn) {
                _context.next = 4;
                break;
              }

              redirectToLogin("notify:".concat(variantId));
              return _context.abrupt("return");

            case 4:
              updateNotifyList = willNotifyAction ? removeItemFromNotifyWishlist : addItemToNotifyWishlist;
              _context.next = 7;
              return updateNotifyList({
                imageUrl: product.assets.hero.url,
                title: product.title,
                offerId: initialOfferId
              }, {
                variantId: variantId,
                notify: !willNotifyAction
              });

            case 7:
              _yield$updateNotifyLi = _context.sent;
              status = _yield$updateNotifyLi.status;

              if (status !== "serverError") {
                emitNotify({
                  product_id: productId,
                  page_type: "product",
                  action: willNotifyAction ? "Remove" : "Add"
                });
              }

              if (!refetch) {
                _context.next = 16;
                break;
              }

              _context.next = 13;
              return refetch({
                productId: productId
              });

            case 13:
              _yield$refetch = _context.sent;
              _data = _yield$refetch.data;
              setWillNotify(!!(_data !== null && _data !== void 0 && (_data$productById4 = _data.productById) !== null && _data$productById4 !== void 0 && _data$productById4.variants.find(function (opt) {
                var _opt$wishlist$wishlis3;

                return (_opt$wishlist$wishlis3 = opt.wishlist.wishlistItem) === null || _opt$wishlist$wishlis3 === void 0 ? void 0 : _opt$wishlist$wishlis3.notify;
              })));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function notifyWishlist(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onWishlistClick = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var variantId,
          _yield$addItemToWishl,
          status,
          wishlist,
          _args2 = arguments;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              variantId = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : defaultVariantId;

              if (isLoggedIn) {
                _context2.next = 4;
                break;
              }

              redirectToLogin("wishlist:".concat(variantId));
              return _context2.abrupt("return");

            case 4:
              if (wishlistItemId) {
                _context2.next = 14;
                break;
              }

              _context2.next = 7;
              return addItemToWishlist({
                imageUrl: product.assets.hero.url,
                title: product.title,
                offerId: initialOfferId
              }, {
                variantId: variantId
              });

            case 7:
              _yield$addItemToWishl = _context2.sent;
              status = _yield$addItemToWishl.status;
              wishlist = _yield$addItemToWishl.data;

              if (status !== "serverError") {
                emitAddToWishlist({
                  product_id: productId,
                  page_type: "product",
                  action: "Add",
                  wishlist: wishlist === null || wishlist === void 0 ? void 0 : wishlist.id,
                  position: 1,
                  source_type: sourceType,
                  event_id: eventId
                });
              }

              setDeletedWishlistProductId(null);
              _context2.next = 20;
              break;

            case 14:
              setOfferLoading(true);
              _context2.t0 = wishlistItemId;

              if (!_context2.t0) {
                _context2.next = 19;
                break;
              }

              _context2.next = 19;
              return removeItemFromWishlist({
                imageUrl: product.assets.hero.url,
                title: product.title,
                offerId: initialOfferId
              }, {
                wishlistItemId: wishlistItemId
              });

            case 19:
              emitAddToWishlist({
                product_id: productId,
                page_type: "product",
                action: "Remove"
              });

            case 20:
              _context2.next = 22;
              return refetch({
                productId: productId
              });

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onWishlistClick() {
      return _ref3.apply(this, arguments);
    };
  }();

  var selectAttribute = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(selectedVariantId) {
      var _data$productById5, _data$productById5$se;

      var _yield$refetch2, data;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setOfferLoading(true);
              _context3.next = 3;
              return refetch({
                selectedVariantId: selectedVariantId,
                selectedOfferId: undefined
              });

            case 3:
              _yield$refetch2 = _context3.sent;
              data = _yield$refetch2.data;

              if (data !== null && data !== void 0 && (_data$productById5 = data.productById) !== null && _data$productById5 !== void 0 && (_data$productById5$se = _data$productById5.selectedOffer) !== null && _data$productById5$se !== void 0 && _data$productById5$se.id) {
                emitProductView({
                  offer_id: selectedOfferId,
                  source_position: 1,
                  source_type: sourceType,
                  source_id: sourceId
                });
              }
              /** Adjust Variant ID, thus add item to wishlist functionality will send correct variant id */


              defaultVariantId = selectedVariantId;

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function selectAttribute(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var selectOffer = function selectOffer(selectedOfferId) {
    var _headerRef$current;

    setOfferLoading(true);
    refetch({
      selectedVariantId: undefined,
      selectedOfferId: selectedOfferId
    });
    headerRef === null || headerRef === void 0 ? void 0 : (_headerRef$current = headerRef.current) === null || _headerRef$current === void 0 ? void 0 : _headerRef$current.scrollIntoView({
      behavior: "smooth"
    });
  };

  var product = data.productById;
  var title = product.title;
  var offer = product.selectedOffer;
  var defaultVariantId = (_offer$variant$id = offer === null || offer === void 0 ? void 0 : (_offer$variant = offer.variant) === null || _offer$variant === void 0 ? void 0 : _offer$variant.id) !== null && _offer$variant$id !== void 0 ? _offer$variant$id : product.variants[0].id; // Remove offers with no purchasableQuantity

  var otherOffers = offer === null || offer === void 0 ? void 0 : (_offer$variant2 = offer.variant) === null || _offer$variant2 === void 0 ? void 0 : _offer$variant2.offers.filter(function (o) {
    return o.purchasableQuantity > 0;
  });

  var _ref5 = offer || {},
      purchasableQuantity = _ref5.purchasableQuantity,
      warranty = _ref5.warranty,
      salesRuleOffers = _ref5.salesRuleOffers;

  var assets = product.assets,
      adult = product.adult,
      sellable = product.sellable,
      personalisedFields = product.personalisedFields;
  var url = assets.hero.url,
      sizeCharts = assets.sizeCharts;
  var redirectAction = cookies.get("productRedirectAction");

  if (isLoggedIn && redirectAction && !wishlistItemId) {
    var _redirectAction$split = redirectAction.split(":"),
        _redirectAction$split2 = _slicedToArray(_redirectAction$split, 2),
        action = _redirectAction$split2[0],
        variantId = _redirectAction$split2[1];

    if (action == "notify") {
      notifyWishlist(variantId);
    } else if (action == "wishlist") {
      onWishlistClick(variantId);
    }

    cookies.remove("productRedirectAction");
  }

  var isGiftCard = product.id == DigitalProductIds.GIFT_CARD;
  var isPersonalisedItem = personalisedFields.length > 0;
  var showCoPurchasedRecommender = offer && !showRecommenderForSellerId(offer === null || offer === void 0 ? void 0 : (_offer$seller = offer.seller) === null || _offer$seller === void 0 ? void 0 : _offer$seller.id);
  var displayDeliveryEstimates = offer && !Object.values(DigitalProductIds).includes(product.id);
  var isEligibleFreeDelivery = isActiveOnePassMember(customerData);

  if (!sellable || !purchasableQuantity) {
    return ___EmotionJSX(BuyBoxContainer, {
      isTablet: isTablet
    }, ___EmotionJSX(SoldOut, {
      inWishlist: !!wishlistItemId,
      onToggleWishlist: onWishlistClick,
      onNotify: function onNotify() {
        return notifyWishlist(defaultVariantId);
      },
      willNotify: willNotify
    }));
  }

  return ___EmotionJSX(Box, {
    position: "relative"
  }, offerLoading && ___EmotionJSX(LoadingSpinner, {
    hasOverlay: true,
    containerProps: {
      style: {
        zIndex: 2
      }
    }
  }), ___EmotionJSX(BuyBoxContainer, {
    isTablet: isTablet,
    pb: {
      xs: 0,
      md: 0
    }
  }, !!(offer !== null && offer !== void 0 && offer.badges.length) && !!(productCardExperiment !== null && productCardExperiment !== void 0 && productCardExperiment.bucket) && ___EmotionJSX(ProductBadge, {
    badges: offer.badges,
    boxShadow: "none",
    containerProps: {
      marginBottom: 3,
      alignItems: {
        xs: "center",
        lg: "flex-start"
      }
    }
  }), (offer === null || offer === void 0 ? void 0 : offer.priceTag) && !isGiftCard && ___EmotionJSX(Flex, {
    mb: 5,
    justifyContent: "space-between",
    flexDirection: {
      xs: "column",
      lg: "row"
    }
  }, !experimentLoading && productCardExperiment !== null && productCardExperiment !== void 0 && productCardExperiment.bucket ? ___EmotionJSX(ProductPriceNew, {
    priceTag: offer.priceTag,
    large: true
  }) : ___EmotionJSX(ProductPrice, {
    priceTag: offer.priceTag,
    large: true
  }), sizeCharts.length > 0 && ___EmotionJSX(SizeChartsButton, {
    charts: sizeCharts,
    mt: 4,
    alignSelf: {
      xs: "center",
      lg: "flex-end"
    }
  })), isPromotionVisibilityExperimentPhase1 && salesRuleOffers && salesRuleOffers.length > 0 && ___EmotionJSX(Flex, {
    my: "20px",
    gap: "10px",
    flexWrap: "wrap",
    justifyContent: {
      xs: "center",
      md: "start"
    }
  }, salesRuleOffers.map(function (promotion) {
    return ___EmotionJSX(SalesRulePromotionTag, {
      key: promotion.id,
      salesRuleId: promotion.id,
      title: promotion.label,
      disclaimerTitle: promotion.disclaimerTitle,
      eventSlug: promotion.eventSlug,
      eventLink: "/event/".concat(promotion.eventSlug, "?salesRuleId=").concat(promotion.id),
      containerProps: {
        fontSize: {
          xs: "sm",
          md: "base"
        }
      }
    });
  })), isPromotionVisibilityExperimentPhase2 && salesRulePromotionProgress && salesRulePromotionProgress.description && ___EmotionJSX(SalesRulePromotionProgress, _extends({
    containerProps: {
      mb: 5
    }
  }, salesRulePromotionProgress)), product.options.length > 0 && product.options.map(function (option) {
    var _offer$variant3, _offer$variant4, _offer$priceTag;

    return ___EmotionJSX(AttributeSelector, {
      key: option.id,
      variants: product.variants.map(function (_ref6) {
        var _offers$;

        var offers = _ref6.offers,
            variant = _objectWithoutProperties(_ref6, _excluded);

        return _objectSpread(_objectSpread({}, variant), {}, {
          price: (_offers$ = offers[0]) === null || _offers$ === void 0 ? void 0 : _offers$.sellPrice.amount
        });
      }),
      option: option,
      onNotify: notifyWishlist,
      selectAttribute: selectAttribute,
      selectedOffer: {
        variantOptionValueId: offer === null || offer === void 0 ? void 0 : (_offer$variant3 = offer.variant) === null || _offer$variant3 === void 0 ? void 0 : _offer$variant3.variantOptionValues[0].id,
        variantId: offer === null || offer === void 0 ? void 0 : (_offer$variant4 = offer.variant) === null || _offer$variant4 === void 0 ? void 0 : _offer$variant4.id,
        price: offer === null || offer === void 0 ? void 0 : (_offer$priceTag = offer.priceTag) === null || _offer$priceTag === void 0 ? void 0 : _offer$priceTag.priceLabel.price.amount
      }
    });
  }), !!purchasableQuantity && !product.options.length && !isGiftCard && !isPersonalisedItem && ___EmotionJSX(QuantitySelector, {
    purchasableQuantity: purchasableQuantity,
    setQuantity: setQuantity
  }), personalisedFields.length > 0 && offer && ___EmotionJSX(PersonalisedFields, {
    personalisedFields: personalisedFields,
    chosenQuantity: chosenQuantity,
    offerId: offer.id,
    title: title,
    imageUrl: url,
    sourceId: sourceId,
    sourceType: sourceType,
    sourcePosition: sourcePosition,
    eventId: eventId,
    onWishlistClick: onWishlistClick,
    inWishlist: !!wishlistItemId
  }), offer !== null && offer !== void 0 && offer.clubExclusive && !customerLoading && !(customerData !== null && customerData !== void 0 && (_customerData$club = customerData.club) !== null && _customerData$club !== void 0 && _customerData$club.active) && !(customerData !== null && customerData !== void 0 && (_customerData$members = customerData.membership) !== null && _customerData$members !== void 0 && (_customerData$members2 = _customerData$members.subscription) !== null && _customerData$members2 !== void 0 && _customerData$members2.active) ? ___EmotionJSX(OnePassExclusive, {
    customer: customerData,
    inWishlist: !!wishlistItemId,
    onToggleWishlist: onWishlistClick
  }) : offer && !personalisedFields.length && ___EmotionJSX(BuyBoxButtons, {
    chosenQuantity: chosenQuantity,
    offerId: offer === null || offer === void 0 ? void 0 : offer.id,
    title: title,
    imageUrl: url,
    sourceId: sourceId,
    sourceType: sourceType,
    sourcePosition: sourcePosition,
    eventId: eventId,
    onWishlistClick: onWishlistClick,
    onAddToCartSuccess: onAddToCartSuccess,
    inWishlist: !!wishlistItemId
  }), offer && ___EmotionJSX(BNPLPaymentMethodsContainer, {
    mb: 6,
    paymentOptions: offer.bnplPaymentMethods,
    offerPrice: ((offer === null || offer === void 0 ? void 0 : (_offer$priceTag2 = offer.priceTag) === null || _offer$priceTag2 === void 0 ? void 0 : (_offer$priceTag2$pric = _offer$priceTag2.priceLabel) === null || _offer$priceTag2$pric === void 0 ? void 0 : _offer$priceTag2$pric.price.amount) || 0) / 100
  }), displayDeliveryEstimates && ___EmotionJSX(BorderBox, isEligibleFreeDelivery ? {
    paddingBottom: "12px"
  } : {}, ___EmotionJSX(DeliveryEstimate, {
    offerId: selectedOfferId
  })), (offer === null || offer === void 0 ? void 0 : offer.clubFreeShipping) && !(offer !== null && offer !== void 0 && offer.clubExclusive) && !customerLoading && ___EmotionJSX(BorderBox, isEligibleFreeDelivery && displayDeliveryEstimates ? {
    borderTop: "none",
    pt: "0px",
    pb: "10px"
  } : {}, ___EmotionJSX(UpsellCTAWidgetContainer, {
    useOnePassVariant: !offer.freeShipping
  })), displayXmasWidget && offer && ___EmotionJSX(BorderBox, null, ___EmotionJSX(ChristmasDeliveryWidget, {
    offerId: offer.id
  })), (offer === null || offer === void 0 ? void 0 : offer.shipping) && ___EmotionJSX(BorderBox, null, ___EmotionJSX(ShippingInformation, {
    shipping: offer.shipping,
    seller: offer.seller,
    purchaseLimit: offer.purchaseLimit,
    offerId: offer.id,
    freeShipping: offer.freeShipping,
    isGiftCard: isGiftCard
  })), warranty && ___EmotionJSX(BorderBox, null, ___EmotionJSX(WarrantyInfo, {
    warranty: warranty
  }))), otherOffers && otherOffers.length > 1 && ___EmotionJSX(OfferSelector, {
    offers: otherOffers,
    selectedOfferId: offer === null || offer === void 0 ? void 0 : offer.id,
    selectOffer: selectOffer
  }), showCoPurchasedRecommender && ___EmotionJSX(CoPurchasedRecommender, {
    product: {
      id: productId,
      offer: offer,
      title: title,
      assets: assets
    },
    eventId: eventId,
    adult: adult
  }));
};